export const PATHS = {
  root: "/",
  login: "/login",
  handovers: {
    root: "/handover-protocol",
    completed: "/handover-protocol/completed",
  },
  zipcodes: {
    root: "/zipcodes",
    add: "/zipcodes/add",
    edit: "/zipcodes/edit/:zipcode",
    visualization: "/zipcodes/visualization",
  },
  tours: {
    root: "/tours",
    add: "/tours/add",
    edit: "/tours/edit/:id",
    detail: "/tours/detail/:id",
    current: "/tours/current",
    recent: "/tours/recent",
    archive: "/tours/archive",
    map: "/map/current",
    export: "/tours/export",
  },
  routes: {
    current: "/routes/current",
    recent: "/routes/recent",
    archive: "/routes/archive",
    export: "/routes/export",
    mapRecent: "/routes/recent/map",
    mapArchive: "/routes/archive/map",
  },
  customers: {
    root: "/customers",
    add: "/customers/add",
    addWithExistingData: "/customers/add-with-existing-data/:id",
    edit: "/customers/edit/:id",
    detail: "/customers/detail/:id",
    view: "/customers/view/:id",
    archive: "/customers/archive",
  },
  orders: {
    root: "/orders",
    add: "/orders/add",
    edit: "/orders/edit/:id",
  },
  admin: {
    accountDetails: "/admin/account-details",
    accountDetailsEdit: "/admin/supplier-details/edit/:id",
    supplierLocationsDetail: "/admin/supplier-locations/detail/:id",
    supplierLocationsEdit: "/admin/supplier-locations/edit/:id",
    supplierLocationsAdd: "/admin/supplier-locations/add",
    supplierLocations: "/admin/supplier-locations",
    supplierGroups: "/admin/supplier-groups",
    supplierGroupsDetail: "/admin/supplier-groups/detail/:id",
    supplierGroupEdit: "/admin/supplier-group/edit/:id",
    supplierGroupsAdd: "/admin/supplier-groups/add",
    roles: "/admin/roles",
    rolesDetail: "/admin/roles/detail/:id",
    roleEdit: "/admin/roles/edit/:id",
    rolesAdd: "/admin/roles/add",
    permissions: "/admin/permissions",
    permissionsDetail: "/admin/permissions/detail/:id",
    permissionEdit: "/admin/permissions/edit/:id",
    permissionAdd: "/admin/permissions/add",
    suppliers: "/admin/suppliers",
    supplierDetail: "/admin/suppliers/detail/:id",
    supplierEdit: "/admin/suppliers/edit/:id",
    supplierAdd: "/admin/suppliers/add",
    users: "/admin/users",
    usersDetail: "/admin/users/detail/:id",
    usersEdit: "/admin/users/edit/:id",
    usersAdd: "/admin/users/add",
    accountPermissions: "/admin/account-permissions",
    accountPermissionEdit: "/admin/account-permissions/edit",
  },
  diagnostics: {
    web: "/diagnostics/web",
    webSettings: "/diagnostics/web/settings",
    feedbackDetail: "/diagnostics/web/feedbacks/:id",
    mobile: "/diagnostics/mobile",
    mobileSettings: "/diagnostics/mobile/settings",
    mobileRouteLogs: "/diagnostics/mobile/routes/:routeId",
    mobileLogDetail: "/diagnostics/mobile/logs/:id",
  },
  pastdeliveries: "/past-deliveries",
  deliveryhistory: "/delivery-history",
  customer: "/dash",
  dashboard: "/dashboard",
  addTour: "/tour/add",
  maps: "/map",
};

export const DEPOSIT_AGREEMENTS = {
  NONE: "None",
  BRING_KEY: "Bring Key",
  KEY_BOX: "Keybox",
};
